import { render, staticRenderFns } from "./Imprint.vue?vue&type=template&id=12dd7c1c&scoped=true"
import script from "./Imprint.vue?vue&type=script&lang=js"
export * from "./Imprint.vue?vue&type=script&lang=js"
import style0 from "./Imprint.vue?vue&type=style&index=0&id=12dd7c1c&prod&lang=css"
import style1 from "./Imprint.vue?vue&type=style&index=1&id=12dd7c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dd7c1c",
  null
  
)

export default component.exports